import { Link } from "react-router-dom";
import { LogoWordmark } from "./Logo";
import { Mail, MapPin } from "lucide-react";

export const SiteFooter = () => (
  <footer className="border-t border-[color:var(--border-soft)] bg-[color:var(--bg)]" data-testid="site-footer">
    <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
        <div className="col-span-2 md:col-span-5">
          <LogoWordmark size={34} />
          <p className="text-[color:var(--muted)] text-[15px] leading-relaxed mt-5 max-w-sm">
            Brand, website, local SEO and invoicing — built and managed for UK tradespeople.
            One monthly payment. No large upfront cost.
          </p>
          <div className="mt-6 flex flex-col gap-2 text-[14px] text-[color:var(--muted)]">
            <a href="mailto:contact@readytrades.co.uk" className="inline-flex items-center gap-2 hover:text-[color:var(--ink)] transition-colors">
              <Mail size={14} strokeWidth={1.75} /> contact@readytrades.co.uk
            </a>
            <span className="inline-flex items-center gap-2">
              <MapPin size={14} strokeWidth={1.75} /> Great Dunmow · Essex · UK
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow mb-4">Explore</p>
          <ul className="space-y-2.5 text-[15px]">
            <li><a href="/#what-you-get" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">What you get</a></li>
            <li><a href="/#how-it-works" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">How it works</a></li>
            <li><a href="/#examples" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Examples</a></li>
            <li><Link to="/pricing" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Pricing</Link></li>
            <li><a href="/#faqs" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">FAQs</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow mb-4">Company</p>
          <ul className="space-y-2.5 text-[15px]">
            <li><Link to="/about" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">About ReadyTrades</Link></li>
            <li><Link to="/our-clients" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Our clients</Link></li>
            <li><Link to="/get-started" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Get your free preview</Link></li>
            <li><Link to="/privacy" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Privacy policy</Link></li>
            <li><Link to="/terms" className="text-[color:var(--ink)] hover:text-[color:var(--accent)] transition-colors">Terms & conditions</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[color:var(--border-soft)] mt-14 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[13px] text-[color:var(--muted)]">
        <p>© {new Date().getFullYear()} ReadyTrades. All rights reserved.</p>
        <p>Made in the United Kingdom.</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
